'use strict';

var el

module.exports = function(){

	if(!el && !!global.document){
	  	el = global.document.createElement('div')
	}

	if (!el){
		el = {style: {}}
	}

	return el
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-style-normalizer/src/el.js
 ** module id = 358
 ** module chunks = 0
 **/